<template>
  <div class="animated fadeIn">
    <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <i class="fa fa-align-justify"></i> Surveys
            </div>
            <div class="card-block">
              <table class="table table-bordered table-striped table-sm">
                <thead>
                  <tr>
                    <th>Department</th>
                    <th>Area</th>
                    <th>Topics</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>GI Lab</td>
                    <td>General Department</td>
                    <td>Attire, Education and Training, Manufacturer IFU&#39;s, Personal Protective
Equipment, Policies and Procedures, Temperature and Relative Humidity, Temperature, Relative
Humidity, and Ventilation, Walls and Floors, and Workflow.</td>
                  </tr>
                  <tr>
                    <td>GI Lab</td>
                    <td>Decontamination</td>
                    <td>Endoscope Sheaths, High-Level Disinfection, High-Level Disinfection – Disinfection,
High-Level Disinfection - Manual Drying, High-Level Disinfection - Manual Rinsing, Leak Test
Failures, Leak Testing, Liquid chemical sterilants/liquid chemical sterilization, Liquid chemical
sterilants/liquid chemical sterilization – Disinfection, Liquid chemical sterilants/liquid chemical
sterilization - Manual Drying, Liquid chemical sterilants/liquid chemical sterilization - Manual
Rinsing, Manual (dry) Leak Testing, Manual (wet) Leak Testing, Manual Cleaning, Manual
Rinsing, Mechanical (dry) Leak Testing, Mechanical Leak Testing using an AER, Personal
Protective Equipment, Single Use High-level Disinfection, Single Use High-level Disinfection –
Disinfection, Single Use High-level Disinfection - Manual Drying, Single Use High-level
Disinfection - Manual Rinsing, Sinks, and Workstations.</td>
                  </tr>
                  <tr>
                    <td>GI Lab</td>
                    <td>Sterilization</td>
                    <td>Hydrogen Peroxide Gas Sterilization, Ozone Sterilization, Sterilization Pouches, and
Sterilization wraps.</td>
                  </tr>
                  <tr>
                    <td>GI Lab</td>
                    <td>Storage</td>
                    <td>General Area, High-Level Disinfected Endoscopes, and Sterilized Endoscopes.</td>
                  </tr>
                  <tr>
                    <td>GI Lab</td>
                    <td>Point of Use: Pre-Transport</td>
                    <td>Point of Use Transport, and Pre-cleaning.</td>
                  </tr>
                  <tr>
                    <td>GI Lab</td>
                    <td>Transport: Point of Use to Decontamination</td>
                    <td>Transportation.</td>
                  </tr>
                  <tr>
                    <td>CSPD</td>
                    <td>General Department</td>
                    <td>Breakout Room, Pre-Entry, Entry, Red Line Protocol, and Vendor Drop Off.</td>
                  </tr>
                  <tr>
                    <td>CSPD</td>
                    <td><router-link :to="{name: 'Survey'}" class="link" exact>Decontamination</router-link></td>
                    <td>Pre-Entry, Entry, Sorting and Disassembly, Disassembly of Rigid Sterilization
Container Systems, Presoaking, Work Stations, Cleaning, Rinsing, Sinks, Manufacturer&#39;s IFU, Chemical
Disinfectant Mechanical Cleaning, Cart Washer, Lighting, Eye Wash Station, Hand Washing Station,
House Keeping, Pass Through Window, Policies &amp; Procedures, Record Keeping, Temperature/Relative
Humidity, The OSHA Blood-Borne Pathogen Regulation, and Ventilation.</td>
                  </tr>
                  <tr>
                    <td>CSPD</td>
                    <td>Prep &amp; Pack</td>
                    <td>Assembly, Inspection, Peel Packing, Surgical Tray/Instrument Tracking System,
Temperature/Relative Humidity, Ventilation, Washer Unloading, Work Stations, Wrapping - Basins and
Basin Sets, Wrapping - Chemical Indicators, Wrapping - Devices with Lumens, Wrapping - Package
Closure, Wrapping - Package Labels, Wrapping - Packaging Configuration and Preparation, Wrapping -
Packaging Materials, Wrapping - Surgical Supplies, and Wrapping - Textile Packs.</td>
                  </tr>
                  <tr>
                    <td>CSPD</td>
                    <td>Sterilization</td>
                    <td>Sterilization, Expiration Dating, Immediate Use ‘Flash’ Sterilization, Sterilization
Staging, Sterilizer records, Table-Top Sterilizers, and Unloading the Sterilizer.</td>
                  </tr>
                </tbody>
              </table>
              <nav>
                <ul class="pagination">
                  <li class="page-item"><a class="page-link" href="#">Prev</a></li>
                  <li class="page-item active">
                    <a class="page-link" href="#">1</a>
                  </li>
                  <li class="page-item"><a class="page-link" href="#">2</a></li>
                  <li class="page-item"><a class="page-link" href="#">3</a></li>
                  <li class="page-item"><a class="page-link" href="#">4</a></li>
                  <li class="page-item"><a class="page-link" href="#">Next</a></li>
                </ul>
              </nav>
            </div>
          </div>
        </div><!--/.col-->
      </div><!--/.row-->



  </div>
</template>
<script>
export default {
  name: 'surveysMain'
}
</script>
